
export const checkForSurvery1 = (survey) => {
    if (survey.includes("-1")) {
        return true
    }

    return false
}

export const checkForSurvery2 = (survey) => {

    if (survey.includes("-2")) {
        return true
    }

    return false

}